import React, { ReactNode } from 'react';
import Link from 'next/link';
import { KarePediaLogo } from './KarePediaLogo';
import Image from 'next/image';
import paLogo from '@/public/paBlog/pa-logo.png';
import cgcLogo from '@/public/cgcBlog/cgcLogo.svg';
import { Platform } from '@/constants';

type Props = {
  isWhiteLogo?: Boolean;
};

export default function Logo({ isWhiteLogo }: Props) {
  let Logo: ReactNode;
  switch (Platform) {
    case 'karetripBlog':
      Logo = (
        <>
          <Image
            src={
              isWhiteLogo
                ? 'https://dxfqlcpql5f3t.cloudfront.net/logos/karetrip-logo-white.svg'
                : 'https://dxfqlcpql5f3t.cloudfront.net/logos/karetrip-logo.svg'
            }
            alt='karetrip-logo'
            className={'h-[30px] w-auto dark:hidden max-sm:h-[22px]'}
            width={100}
            height={100}
          />
          <Image
            src={`https://dxfqlcpql5f3t.cloudfront.net/logos/karetrip-logo-white.svg`}
            alt='karetrip-logo'
            className={'hidden h-[33px] w-auto dark:block max-sm:h-[22px]'}
            width={100}
            height={100}
          />
        </>
      );
      break;
    case 'mykareBlog':
      Logo = (
        <Image
          src={`https://mykare-logos.s3.ap-south-1.amazonaws.com/mykare/mykareLogo.png`}
          alt='Mykare-Logo'
          className={'h-[40px] w-auto max-sm:h-[30px]'}
          width={100}
          height={100}
        />
      );
      break;
    case 'karePedia':
      Logo = <KarePediaLogo isWhiteLogo={isWhiteLogo} />;
      break;
    case 'paBlog':
      Logo = (
        <Image
          src={paLogo}
          alt='Pa-Logo'
          className={'h-[40px] w-auto'}
          width={100}
          height={100}
        />
      );
    case 'cgcBlog':
      Logo = (
        <Image
          src={cgcLogo}
          alt='cgc-Logo'
          className={'h-[40px] w-auto'}
          width={100}
          height={1300}
          quality={100}
        />
      );
  }
  return (
    <section className='w-1/4 max-lg:w-full'>
      <Link
        href={'https://www.chennaigastrocare.in'}
        className='h-[46px] w-auto cursor-pointer'
      >
        {Logo}
        <span className='sr-only'>Logo</span>
      </Link>
    </section>
  );
}
